import {useQuery} from 'react-query'
// import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {getAuditById} from '../core/_requests'
import {useListView} from '../core/ListViewProvider'
import {AuditEditModalForm} from './AuditEditModalForm'
import { isNotEmpty, QUERIES } from 'src/_metronic/helpers'

const AuditEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: audit,
    error,
  } = useQuery(
    `${QUERIES.SERVICECENTERS_LIST}-audit-${itemIdForUpdate}`,
    () => {
      return getAuditById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <AuditEditModalForm isAuditLoading={isLoading} audit={{id: undefined}} />
  }

  if (!isLoading && !error && audit) {
    return <AuditEditModalForm isAuditLoading={isLoading} audit={audit} />
  }

  return null
}

export {AuditEditModalFormWrapper}
